import { useMutation } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

interface ICreateAssessmentVariables {
  name: string;
  isPublic: boolean;
  isPractice?: boolean;
}

interface ICreateAssessmentBody {
  name: string;
  is_public: boolean;
  is_practice?: boolean;
}

interface ICreateAssessmentResponse extends ICreateAssessmentBody {
  uid: string;
  company: string;
}

const useCreateAssessment = () => {
  const {
    mutateAsync: createAssessment,
    data,
    isLoading,
    error,
  } = useMutation<ICreateAssessmentResponse, Error, ICreateAssessmentVariables>(
    ['createAssessment'],
    async ({ name, isPublic, isPractice }) => {
      const body = {
        name,
        is_public: isPublic,
        is_practice: !!isPractice,
      };

      const user = await fetchWithCsrfToken<ICreateAssessmentResponse>(
        `${PrependUrl.ASYNC}/assessment/create`,
        'POST',
        body
      );

      return user;
    }
  );

  return {
    createAssessment,
    data,
    isLoading,
    error,
  };
};

export default useCreateAssessment;
